var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_interface_active",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL1_wght400_GRAD0_opsz48",
    d: "M86.394,186.912l5.306-5.306-.862-.844-4.444,4.444-2.25-2.25-.844.844ZM87.5,191a7.257,7.257,0,0,1-2.906-.591,7.556,7.556,0,0,1-4-4,7.492,7.492,0,0,1,0-5.831,7.5,7.5,0,0,1,1.613-2.381,7.688,7.688,0,0,1,2.391-1.6,7.492,7.492,0,0,1,5.831,0,7.488,7.488,0,0,1,3.984,3.984,7.492,7.492,0,0,1,0,5.831,7.689,7.689,0,0,1-1.6,2.391,7.5,7.5,0,0,1-2.381,1.613A7.3,7.3,0,0,1,87.5,191Z",
    transform: "translate(-80 -176)",
    fill: "green"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenIcon);
export default __webpack_public_path__ + "static/media/green-icon.ab3a1b5e043d3fe87f703bf137dbb2a0.svg";
export { ForwardRef as ReactComponent };